import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const CardAuthenticationRoutes: Routes = [
  {
    path: "card-authentication",
    loadComponent: () =>
      import("./card-authentication.component").then(
        (m) => m.CardAuthenticationComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./card-authentication-form/card-authentication-form.component").then(
            (m) => m.CardAuthenticationFormComponent,
          ),
      },
    ],
  },
];
